<template>
	<div
		style="position: absolute;width:300px;background-color: #2f3638;z-index: 9999;right: 10px;top: 38px;border: 1px solid #525e62;padding: 10px;" @click.stop="">
		<div class="box">
			<div class="box-item" v-for="(item,index) in list" :key="index" @click="getInfo(item)">
				<div style="display: flex;flex-direction: column;font-size: 14px;">
					<div>{{item.title}}</div>
					<div style="font-size: 11px;margin-top: 10px;">{{item.create_time}}</div>
				</div>
				<div style="flex-shrink: 0;font-size: 14px;font-weight: 700;margin-left: auto;">
					<span>{{item.status===1?'已读':'未读'}}</span>
				</div>
			</div>
			<div style="padding: 10px;display: flex;align-items: center;justify-content: center;background-color: rgba(255, 255,255, 0.3);cursor: pointer;" @click="getNext">
				{{has_next?'点击加载更多':'没有更多了！'}}
			</div>
		</div>
		<el-dialog :title="info.title" :visible.sync="dialogInfoVisible" width="300px">
			<div style="font-size: 14px;margin-bottom: 10px;padding: 5px;font-size: 12px;">
				{{info.content}}
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				list: [],
				info:{},
				dialogInfoVisible:false,
				page:1,
				has_next:true
			}
		},
		created() {
			this.page = 1
			this.has_next = true
			this.getList()
			
		},
		methods: {
			getNext(){
				if(this.has_next){
					this.page +=1
					this.getList()
				}
			},
			getInfo(item){
				
				this.$H.post('/verify_center/v1_0_1.Notice/GetInfo', {
					id: item.id
				}).then(res => {
					if (res.data) {
						this.$store.dispatch('setUserInfo')
						this.info = res.data.info
						this.$H.post('verify_center/v1_0_1.Notice/Read',{
							id: item.id
						}).then(res=>{
							item.status = 1
							this.$store.dispatch('setUserInfo')
							setTimeout(()=>{
								this.dialogInfoVisible = true
							},500)
						})
						
					}
				
				})
			},
			getList() {
				this.$H.post('/verify_center/v1_0_1.Notice/List', {
					page: this.page
				}).then(res => {
					if (res.data) {
						if(res.data.list.data.length==0){
							return this.has_next = false
						}
						this.list = this.page ===1? res.data.list.data:[...this.list,...res.data.list.data]
						
					}

				})
			},
		}
	}
</script>

<style>
	.box {
		height: 400px;
		overflow-y: auto;
	}

	.box::-webkit-scrollbar {
		display: none;
	}

	.box-item {
		border-bottom: 1px solid #525e62;
		display: flex;
		align-items: flex-start;
		color: #cfcfcf;
		padding: 12px;
		cursor:pointer;
	}
	.box-item:hover{
		background-color: rgba(255, 255, 255, 0.1);
	}
</style>